import { loadPoptip } from "@visactor/vrender-components";

import "@visactor/vrender-core";

import { container, isBrowserEnv, isNodeEnv, preLoadAllModule, registerFlexLayoutPlugin } from "@visactor/vrender-core";

import { loadBrowserEnv, loadNodeEnv, registerArc, registerCircle, registerGroup, registerImage, registerLine, registerRect, registerRichtext, registerShadowRoot, registerSymbol, registerText } from "@visactor/vrender-kits";

let registed = !1;

export function registerForVrender() {
    registed || (registed = !0, preLoadAllModule(), isBrowserEnv() ? loadBrowserEnv(container) : isNodeEnv() && loadNodeEnv(container), 
    registerArc(), registerCircle(), registerGroup(), registerImage(), registerLine(), 
    registerRect(), registerRichtext(), registerShadowRoot(), registerSymbol(), registerText(), 
    registerFlexLayoutPlugin(), loadPoptip(), registerFlexLayoutPlugin());
}

export { GroupFadeIn } from "@visactor/vrender-core";

export { GroupFadeOut } from "@visactor/vrender-core";

export * from "@visactor/vrender-core";

export * from "@visactor/vrender-kits";

export * from "@visactor/vrender-components";
//# sourceMappingURL=vrender.js.map